import React, { useEffect, useContext } from 'react';
import './GraduateProfile.scss';

import ReactMarkdown from 'react-markdown';
import { FaFilePdf, FaExternalLinkAlt } from 'react-icons/fa';

// CONTEXT
import CurriculumContext from '../../../../../contexts/pages/curriculum/curriculumContext';
import perfilPdf from '../../../../../assets/pdf/PERFIL DE EGRESO BABEQUE.pdf';

const GraduateProfile = () => {

    const aboutusContext = useContext(CurriculumContext)
    const { profile, getCurriculum } = aboutusContext;

    useEffect(() => {
        getCurriculum();
        // eslint-disable-next-line
    }, [])
  

    return (
        <div className="profile-model">
            <h1 className="profile-model-title">{profile ? profile.titulo : "Perfil del Egresado"}</h1>
            <div className="profile-model-inner">
                {profile && profile.descripcion && (
                    <div className="profile-model-text">
                        <ReactMarkdown>
                            {profile.descripcion}
                        </ReactMarkdown>
                    </div>
                )}

                <div className="pdf-container">
                    <div className="pdf-actions">
                        <a 
                            href={perfilPdf} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="pdf-download-btn"
                        >
                            <FaFilePdf size={18} />
                            <span>Abrir / Descargar PDF</span>
                            <FaExternalLinkAlt size={13} style={{ marginLeft: "4px" }} />
                        </a>
                    </div>
                    <iframe
                        src={`${perfilPdf}#toolbar=1`}
                        title="Perfil del Egresado Babeque"
                        className="pdf-iframe"
                    />
                </div>
            </div>
        </div>
    )
}

export default GraduateProfile;